import React from 'react';
import { useLocalize } from '@saviynt/common';
import { Box, Button, Icon } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ModuleDetails } from '../../../../models/PamModels';
import { MODAL_PAGE_KINDS } from '../../../ModalPageForms/constants';
import { msgs } from '../../constants';

import './SpfAccounts.css';

function SpfAccounts({
  data,
  credentialRequestOnClick,
  dataTestId,
  className,
}) {
  const classes = classnames('SpfAccounts', className);
  const isCredentialed = data.pamType?.toUpperCase() === 'CREDENTIAL';
  const isCredentialless = data.pamType?.toUpperCase() === 'CREDENTIALLESS';

  const localize = useLocalize();

  const hasCredentialType = isCredentialed || isCredentialless;

  const renderBothButtons = () => (
    <Box className='SpfAccounts-twoButtons'>
      <Button
        type='button'
        kind='outlined'
        className='SpfAccounts-twoButtons--buttonStyle'
        onClick={() => credentialRequestOnClick(MODAL_PAGE_KINDS.COC)}
        leftIcon={
          <Icon
            kind='PasswordCredentialUnlock'
            size='smallMedium'
            color='neutral-100'
          />
        }>
        {localize(msgs.pam.sidePanel.checkoutCredentials)}
      </Button>
      <Button
        type='button'
        kind='outlined'
        className='SpfAccounts-twoButtons--buttonStyle'
        onClick={() => credentialRequestOnClick(MODAL_PAGE_KINDS.CTS)}
        leftIcon={
          <Icon kind='Connect' size='smallMedium' color='neutral-100' />
        }>
        {localize(msgs.pam.sidePanel.connectToSession)}
      </Button>
    </Box>
  );

  return (
    <Box className={classes} dataTestId={dataTestId}>
      {hasCredentialType ? (
        <Button
          leftIcon={
            <Icon
              kind={isCredentialed ? 'PasswordCredentialUnlock' : 'Connect'}
              size='smallMedium'
              color='neutral-100'
            />
          }>
          {isCredentialed
            ? localize(msgs.pam.sidePanel.checkoutCredentials)
            : localize(msgs.pam.sidePanel.connectToSession)}
        </Button>
      ) : (
        renderBothButtons()
      )}
    </Box>
  );
}

SpfAccounts.propTypes = {
  data: ModuleDetails,
  dataTestId: PropTypes.string,
  credentialRequestOnClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

SpfAccounts.defaultProps = {
  data: null,
  dataTestId: null,
  className: null,
};

export default SpfAccounts;
